export const pushCurrentDietCalculationStateToHistory = (cartItemId, dietId, phaseId, phaseStep) => {
    const updatedCalculationDietUrl = `${window.location.pathname}?${cartItemId ? `cartItemId=${cartItemId}&` : ''}${
        dietId ? `dietId=${dietId}&` : ''
    }phaseId=${phaseId}&phaseStep=${phaseStep}`;

    pushHistoryState(updatedCalculationDietUrl);
};

const pushHistoryState = (url) => {
    history.pushState(null, null, url);
};
